import mlModelRouterPaths from './mlModelRouterPaths';

export default mlModelRouterPaths;
